export default __webpack_public_path__ + "static/media/CNo.61-0.7732b6d1.jpg";